/**
 * avatars/presets/shirt-colors.js
 * Bảng màu áo chuẩn mặc định cho từng loại trang phục (outfitId)
 */

export function getDefaultShirtColor(outfitId) {
  switch (outfitId) {
    case 'grab':
      return '#00B14F';
    case 'be':
      return '#facc15';
    case 'xanh_sm':
      return '#06b6d4';
    case 'ao_dai':
      return '#ffffff';
    case 'ao_ba_ba':
      return '#78350f';
    case 'hoc_sinh_vn':
      return '#ffffff';
    case 'so_mi':
      return '#f8fafc';
    case 'suit':
      return '#1e293b';
    case 'ao_ba_lo':
      return '#f8fafc';
    case 'shopee':
      return '#ea580c';
    case 'bao_ve':
      return '#38bdf8';
    case 'so_mi_can_bo':
      return '#f1f5f9';
    case 'genz_oversize':
      return '#1e1b4b';
    case 'tien_loi':
      return '#dc2626';
    case 'lab_coat':
      return '#f8fafc';
    case 'lava_suit':
      return '#7f1d1d';
    case 'mech_armor':
      return '#0f172a';
    case 'astral_robe':
      return '#f8fafc';
    case 'cryo_plate':
      return '#0284c7';
    case 'bio_suit':
      return '#065f46';
    case 'magma_male':
      return '#1c1917';
    case 'magma_female':
      return '#7f1d1d';
    case 'bionic_male':
      return '#1e293b';
    case 'bionic_female':
      return '#f1f5f9';
    case 'cryo_male':
      return '#0369a1';
    case 'cryo_female':
      return '#bae6fd';
    case 'ocean_male':
      return '#0c4a6e';
    case 'ocean_female':
      return '#0d9488';
    case 'mycelium_male':
      return '#14532d';
    case 'mycelium_female':
      return '#065f46';
    case 'synapse_male':
      return '#09090b';
    case 'synapse_female':
      return '#2e1065';
    case 'aurora_male':
      return '#022c22';
    case 'aurora_female':
      return '#1e1b4b';
    case 'ossified_male':
      return '#1c1917';
    case 'ossified_female':
      return '#44403c';
    case 'quantum_male':
      return '#1e293b';
    case 'quantum_female':
      return '#ffffff';
    case 'drakonis_male':
      return '#450a0a';
    case 'drakonis_female':
      return '#881337';
    case 'cyclopia_male':
      return '#1e1b4b';
    case 'cyclopia_female':
      return '#3b0764';
    case 'sylva_male':
      return '#3f6212';
    case 'sylva_female':
      return '#4d7c0f';
    case 'insect_male':
      return '#78350f';
    case 'insect_female':
      return '#92400e';
    case 'venom_male':
      return '#047857';
    case 'venom_female':
      return '#065f46';
    case 'dune_male':
      return '#b45309';
    case 'dune_female':
      return '#92400e';
    case 'seraph_male':
      return '#fef9c3';
    case 'seraph_female':
      return '#fef08a';
    case 'lithos_male':
      return '#334155';
    case 'lithos_female':
      return '#475569';
    case 'gem_male':
      return '#ea580c';
    case 'gem_female':
      return '#f97316';
    case 'mercury_male':
      return '#475569';
    case 'mercury_female':
      return '#334155';
    case 'midas_male':
      return '#d97706';
    case 'midas_female':
      return '#b45309';
    case 'steampunk_male':
      return '#78350f';
    case 'steampunk_female':
      return '#854d0e';
    case 'fulgor_male':
      return '#0284c7';
    case 'fulgor_female':
      return '#0369a1';
    case 'astral_male':
      return '#312e81';
    case 'astral_female':
      return '#1e1b4b';
    case 'zephyr_male':
      return '#0284c7';
    case 'zephyr_female':
      return '#0369a1';
    case 'radiation_male':
      return '#4d7c0f';
    case 'radiation_female':
      return '#365314';
    case 'graviton_male':
      return '#44403c';
    case 'graviton_female':
      return '#57534e';
    case 'chrono_male':
      return '#ca8a04';
    case 'chrono_female':
      return '#854d0e';
    case 'nebula_male':
      return '#9333ea';
    case 'nebula_female':
      return '#7e22ce';
    case 'void_male':
      return '#0f172a';
    case 'void_female':
      return '#1e293b';
    case 'singularity_male':
      return '#0f172a';
    case 'singularity_female':
      return '#1d4ed8';
    default:
      return '#0284c7';
  }
}
